import styled from "styled-components";

import { Column } from "@ui/Atoms";
import { rgba } from "@ui/helpers";

import { GatsbyImage } from "../../../../../components/GatsbyImage";

export const Root = styled.div.attrs({ as: "section" })`
  position: relative;
  height: 873px;

  ${props => props.theme.breakpoints.tablet} {
    height: 763px;
  }

  ${props => props.theme.breakpoints.desktop} {
    height: 561px;
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    height: 732px;
  }
`;

export const BackgroundImage = styled(GatsbyImage)`
  width: 100%;
  position: absolute !important;
  top: 220px;
  height: calc(100% - 220px);

  ${props => props.theme.breakpoints.tablet} {
    top: 180px;
    height: calc(100% - 180px);
  }

  ${props => props.theme.breakpoints.desktop} {
    top: 0;
    height: 100%;
  }
`;

export const Gradient = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: ${({ theme }) =>
    `linear-gradient(184.26deg, ${rgba(theme.palette.black)} 28.37%, ${rgba(
      theme.palette.black,
      0,
    )} 45.04%)`};

  ${props => props.theme.breakpoints.desktop} {
    background-image: ${({ theme }) =>
      `linear-gradient(113.72deg, ${rgba(
        theme.palette.black,
        0.42,
      )} 37.01%, ${rgba(theme.palette.black, 0)} 69.24%)`};
  }
`;

export const ContentWrapper = styled(Column).attrs({
  xs: 12,
  pushMd: 1,
  md: 7,
  pushLg: 1,
  lg: 4,
  pushXl: 1,
  xl: 4,
})`
  z-index: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  padding-top: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    padding-top: ${({ theme }) => theme.spacing.spacing_64};
  }

  ${props => props.theme.breakpoints.desktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_80};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_12};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    flex-direction: row;
  }

  ${props => props.theme.breakpoints.desktop} {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.spacing_24};
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing.spacing_32};
  }

  > * {
    flex: 1;
  }
`;
